export const tourData = [
  {
    id: 1,
    city: "Agra",
    img: "./img/img-1.jpg",
    name: "Taj Mahal",
    info: 
        "The Taj Mahal is an ivory-white marble mausoleum on the southern bank of the river Yamuna in the Indian city of Agra. It was commissioned in 1632 by the Mughal emperor Shah Jahan to house the tomb of his favourite wife, Mumtaz Mahal; it also houses the tomb of Shah Jahan himself."
  },
  {
    id: 2,
    city: "New Delhi",
    img: "./img/img-2.jpg",
    name: "Red Fort",
    info:
      "The Red Fort is a historic fort in the city of Delhi in India that served as the main residence of the Mughal Emperors. Emperor Shah Jahan commissioned construction of the Red Fort on 12 May 1638, when he decided to shift his capital from Agra to Delhi."
  },
  {
    id: 3,
    city: "Mumbai",
    img: "./img/img-3.jpg",
    name: "Chhatrapati Shivaji Terminus",
    info:
      "Mumbai Chhatrapati Shivaji Maharaj Terminus, also known by its former name Mumbai Victoria Terminus and Mumbai Chhatrapati Shivaji Terminus, is a historic terminal train station and UNESCO World Heritage Site in Mumbai, Maharashtra, India. "
  },
  {
    id: 4,
    city: "Chittorgarh, Rajasthan",
    img: "./img/img-4.jpg",
    name: "Chittor Fort ",
    info:
      "The Chittor Fort or Chittorgarh is one of the largest forts in India. It is a UNESCO World Heritage Site. The fort was the capital of Mewar and is located in the present-day town of Chittor. It sprawls over a hill 180 m in height spread over an area of 280 ha above the plains of the valley drained by the Berach River."
  }
];
